import { useSettings } from '@wu/widget-core';
import { formatSalaryAmount } from '../../../utils';

type SalaryBucket = {
  low: number | null;
  high: number | null;
};

export function useFormatSalaryRange() {
  const { language } = useSettings();
  const { language: locale = 'en' } = language;

  return (bucket: SalaryBucket, currency: string) => {
    const format = (amount: number | null) =>
      amount == null ? '' : formatSalaryAmount({ amount, currency, locale });

    const { low, high } = bucket;
    if (low == null && high != null) {
      return `< ${format(high)}`;
    }
    if (low != null && high == null) {
      return `> ${format(low)}`;
    }
    return `${format(low)} – ${format(high)}`;
  };
}
